import store from '@/store/store';

export default function agenceInitialize(dcf) {
  const agences = store.getters['societe/agenceActive'];
  const user = store.getters['user/user'];

  if (!dcf.agenceId && agences.find((agence) => {
    return agence.agenceId === user.agenceId;
  })) {
    dcf.agenceId = user.agenceId;
  }
  if (!dcf.agenceId) dcf.agenceId = agences[0].agenceId;
}
